
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { 
  Home, Users, CreditCard, ClipboardList, 
  BarChart3, Settings, HelpCircle, ExternalLink, FileCode2
} from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

const AppSidebar: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();
  
  const navItems = [
    { name: 'Tableau de bord', path: '/', icon: <Home className="h-5 w-5" /> },
    { name: 'Abonnements', path: '/subscriptions', icon: <CreditCard className="h-5 w-5" /> },
    { name: 'Équipe', path: '/team', icon: <Users className="h-5 w-5" /> },
    { name: 'Historique', path: '/history', icon: <ClipboardList className="h-5 w-5" /> },
    { name: 'Rapports', path: '/reports', icon: <BarChart3 className="h-5 w-5" /> },
    { 
      name: 'Implémentation Stripe', 
      path: '/stripe-implementation', 
      icon: <ExternalLink className="h-5 w-5" />,
      admin: true
    },
    { 
      name: 'API Stripe', 
      path: '/stripe-api-docs', 
      icon: <FileCode2 className="h-5 w-5" />,
      admin: true
    },
  ];
  
  // Filtrer les éléments de navigation pour les admin si nécessaire
  const filteredNavItems = navItems.filter(item => {
    // Afficher uniquement les éléments d'administration si l'utilisateur est admin
    if (item.admin) {
      return user?.email?.includes('admin') || user?.email?.includes('zan.agency');
    }
    return true;
  });
  
  return (
    <div className="h-full px-3 py-4 flex flex-col bg-white border-r">
      <div className="space-y-2 flex-1">
        {filteredNavItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              cn(
                "flex items-center p-2 text-base font-normal rounded-lg",
                "hover:bg-gray-100 transition-colors",
                isActive ? "bg-gray-100 text-primary" : "text-gray-700"
              )
            }
          >
            <span className="flex-shrink-0">{item.icon}</span>
            <span className="ml-3">{item.name}</span>
          </NavLink>
        ))}
      </div>
      
      <div className="pt-4 mt-4 border-t border-gray-200">
        <NavLink 
          to="#" 
          className="flex items-center p-2 text-base font-normal rounded-lg text-gray-700 hover:bg-gray-100"
        >
          <Settings className="h-5 w-5" />
          <span className="ml-3">Paramètres</span>
        </NavLink>
        
        <NavLink 
          to="#" 
          className="flex items-center p-2 text-base font-normal rounded-lg text-gray-700 hover:bg-gray-100"
        >
          <HelpCircle className="h-5 w-5" />
          <span className="ml-3">Aide</span>
        </NavLink>
      </div>
    </div>
  );
};

export default AppSidebar;
